import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../components/user-avatar';

import style from './user-avatar-and-name.module.less';

const UserAvatarAndName = ({ name = '', userName = '', imgUrl = '' }) => (
  <div className={style.container}>
    <span className={style.avatar}>
      <UserAvatar imgUrl={imgUrl} name={name} userName={userName} />
    </span>
    <div>{name || userName}</div>
  </div>
);

UserAvatarAndName.propTypes = {
  userName: PropTypes.string,
  name: PropTypes.string,
  imgUrl: PropTypes.string,
};

export default UserAvatarAndName;
